'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-tooltip/dist/decorators/getEffect.js
// module id = 443
// module chunks = 95715928098905 215214246568271